/* eslint-disable react/no-array-index-key */
import { FC } from 'react'
import { Breadcrumb } from 'rsuite'
import { useNavigate } from 'react-router'
import './Breadcrum.scss'

export interface BreadcrumbItemType {
  label: string;
  path?: string;
  isActive?: boolean;
}

interface PageBreadcrumbProps {
  items: BreadcrumbItemType[];
}

const BreadcrumHeader: FC<PageBreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate()

  return (
    <Breadcrumb className="breadcrumb" separator=">">
      <Breadcrumb.Item onClick={() => navigate('/')}>Dashboard</Breadcrumb.Item>
      {items.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          onClick={() => {
            if (!item.isActive && item.path) navigate(item.path)
          }}
          active={item.isActive}
        >
          {item.label}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default BreadcrumHeader
